/**
 *
 * @param device - "iphone, android, windows etc."
 */ export const isDevice = (device)=>{
    const r = new RegExp(device, 'i');
    return r.test(navigator.userAgent);
};
